import React, { useState } from "react";
import "./AddUser.css";
import Header from "../../layouts/Employee/Header";
import SubHeader from "../../layouts/Admin/SubHeader";
import AddUserLayout from "../../layouts/Admin/AddUserLayout";

const AddUser = () => {
  return (
    <>
      <Header />
      <SubHeader />
      <AddUserLayout />
    </>
  );
};

export default AddUser;
